import { PagedResult } from "@iventis/domain-model/model/pagedResult";
import { SearchResult } from "@iventis/domain-model/model/searchResult";
import { MapObject } from "@iventis/domain-model/model/mapObject";
import { SearchMapObject } from "@iventis/domain-model/model/searchMapObject";
import { ReactNode } from "react";
import { AxiosInstance } from "axios";
import { SearchResultGroupInterface } from "../interface/search-result-interface";
import { MapObjectSearchOptions, SearchResultType } from "../types/types";

export class MapObjectSearchResult extends SearchResultGroupInterface<MapObject> {
    constructor(name: string, type: SearchResultType, icon: ReactNode, mapId: string, onResultClicked: (result: MapObject) => void, options: MapObjectSearchOptions) {
        super(name, type, icon, onResultClicked);
        this.api = options.api;
        this.getLayers = options.getLayers;
        this.mapId = mapId;
    }

    private readonly mapId: string;

    private readonly api: AxiosInstance;

    private readonly getLayers: () => { id: string; thumbnailUrl: Promise<string> }[];

    public async getResults(searchString: string): Promise<{ type: SearchResultType; results: SearchResult<MapObject & { thumbnailUrl: Promise<string> }>[] }> {
        // Only ever want one page of results from the search as we only need to display three results
        const config = { params: { pageNumber: 1, pageSize: 3 } };
        const layers = this.getLayers();
        const searchBody: SearchMapObject = { layerIds: layers.map(({ id }) => id), searchString };
        const response = await this.api.post<PagedResult<SearchResult<MapObject>[]>>(`/maps/${this.mapId}/map_objects/search`, searchBody, config);
        // Map the map object with the layer's thumbnail
        const mapObjectsWithThumbnail = response.data.results.map((mapObject) => ({
            ...mapObject,
            result: { ...mapObject.result, thumbnailUrl: layers.find(({ id }) => id === mapObject.result.layerId).thumbnailUrl },
        }));
        return {
            type: this.type,
            results: mapObjectsWithThumbnail,
        };
    }
}
